"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompareProducts = exports.COMPARE_PARAM = void 0;
const react_1 = require("react");
const Types_1 = require("@/Types");
const Utils_1 = require("@/Utils");
const compare_1 = require("@/Endpoints/compare");
const react_router_dom_1 = require("react-router-dom");
const useInitialData_1 = __importDefault(require("@/Hooks/useInitialData"));
const Constants_1 = require("@/Constants");
exports.COMPARE_PARAM = 'compareItems';
const deleteCompareItemsParam = (searchParams) => {
    if (!searchParams) {
        return searchParams;
    }
    const params = new URLSearchParams(searchParams);
    if (params.has(exports.COMPARE_PARAM)) {
        params.delete(exports.COMPARE_PARAM);
    }
    const paramsString = params.toString();
    return paramsString && `?${paramsString}`;
};
const useCompareProducts = (setFamilyPageState, setSavedListingFilters) => {
    var _a;
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const initialData = (0, useInitialData_1.default)();
    const isEurope = Constants_1.EUROPE.includes((_a = initialData === null || initialData === void 0 ? void 0 : initialData.continent) === null || _a === void 0 ? void 0 : _a.toLowerCase());
    const cookieCatalogueLanguage = (0, Utils_1.getCookie)(Constants_1.Cookies.CATALOG_LANGUAGE_COOKIE_NAME);
    const languageParam = cookieCatalogueLanguage && isEurope ? JSON.parse(cookieCatalogueLanguage).code : (0, Utils_1.getLanguage)();
    const [compareProductPartNumbers, setCompareProductPartNumbers] = (0, react_1.useState)([]);
    const [isCompareLoading, setIsCompareLoading] = (0, react_1.useState)(false);
    const [cachedProductsForComparison, setCachedProductsForComparison] = (0, react_1.useState)([]);
    const [compareProducts, setCompareProducts] = (0, react_1.useState)([]);
    const setCompareSearchParams = (productNumbers) => {
        const selectedProductNumbers = productNumbers || compareProductPartNumbers;
        setSavedListingFilters(deleteCompareItemsParam(window.location.search));
        window.history.replaceState({}, '', `${window === null || window === void 0 ? void 0 : window.location.pathname}?${exports.COMPARE_PARAM}=${selectedProductNumbers.join(',')}`);
    };
    const onCompareProducts = (productNumbers) => {
        const selectedProductNumbers = productNumbers || compareProductPartNumbers;
        const isCached = (0, Utils_1.compareStringArrays)(selectedProductNumbers, cachedProductsForComparison) &&
            selectedProductNumbers.length === compareProducts.length;
        if (isCached) {
            setFamilyPageState(Types_1.EFamilyPageStates.COMPARE);
            setCompareSearchParams();
        }
        else {
            setIsCompareLoading(true);
            (0, compare_1.getProductsCompareInfo)((0, Utils_1.changeLanguageLocaleInUrl)(pathname, languageParam), {
                partNumberList: selectedProductNumbers
            })
                .then(result => {
                if (result.data.length) {
                    setCompareProducts(result.data);
                    setFamilyPageState(Types_1.EFamilyPageStates.COMPARE);
                    setCompareSearchParams(selectedProductNumbers);
                }
                setCachedProductsForComparison(selectedProductNumbers);
            })
                .catch(() => {
                setCachedProductsForComparison([]);
            })
                .finally(() => setIsCompareLoading(false));
        }
    };
    return {
        onCompareProducts,
        compareProducts,
        setCompareProducts,
        isCompareLoading,
        compareProductPartNumbers,
        setCompareProductPartNumbers
    };
};
exports.useCompareProducts = useCompareProducts;
